import React, { useState } from "react";
import { deleteTemplate } from "../../Context/Template";
import "../Partials/Remove.css";

interface RemoveProps {
  templateName: string;
  templateURL: string;
  onClose: () => void;
  onDeleted: () => void;
}

const Remove: React.FC<RemoveProps> = ({ templateName, templateURL, onClose, onDeleted }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    const res = await deleteTemplate(templateURL);
    if (res) {
      onDeleted();
      onClose();
    }
    setDeleting(false);
  };

  return (
    <div className="rm-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Delete template confirmation">
      <div className="rm-modal" onClick={e => e.stopPropagation()}>
        <div className="rm-icon-wrap">
          <svg className="rm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <line x1="10" y1="11" x2="10" y2="17" />
            <line x1="14" y1="11" x2="14" y2="17" />
          </svg>
        </div>

        <div className="rm-title">Delete template</div>
        <p className="rm-body">
          Are you sure you want to delete <strong>{templateName}</strong>? This action cannot be undone.
        </p>

        <div className="rm-actions">
          <button
            className="rm-btn rm-btn-cancel"
            onClick={onClose}
            disabled={deleting}
            aria-label="Cancel deletion"
          >
            Cancel
          </button>
          <button
            className="rm-btn rm-btn-delete"
            onClick={handleDelete}
            disabled={deleting}
            aria-label="Delete template"
          >
            {deleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Remove;
